import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment-timezone';
moment.tz.setDefault('Asia/Seoul');
import { DivisionStatsForm, DivisionStatsResult } from 'components/DivisionStats';
import { LoadingBar } from 'components/Commons';

import * as cm_action from 'actions/commons';
import * as usg_action from 'actions/usage';

import cm from 'helpers/commons';
import toastr from 'helpers/toastr';

const defaultProps = {};

class DivisionStats extends Component {
  constructor(props) {
    super(props);
    this.state = { divisionFailed: false };
  }

  componentWillMount() {
    cm.propsInit(this.props);
    //부서 조회
    this.divisionSearch();
  }

  componentDidMount() {
    cm.mainTitle('부서 통계');
    //부서 통계 목록
    this.divisionStatList();
  }

  //부서 search
  divisionSearch = async () => {
    try {
      const { cmAPI } = this.props;
      await cmAPI.divisionList();
    } catch (e) {
      console.log('###### divisionSearch : ', e);
    }
    // 조회 실패(reject·errorBind) 시 division이 비어 로딩바가 안 꺼지므로 실패 표시
    const { division } = this.props;
    if (!division) this.setState({ divisionFailed: true });
  };

  submitForm = (e) => {
    e.preventDefault();
    const { dateCheck } = this.props;

    if (!dateCheck.isValue.isState) {
      toastr('top-right', 'warning', dateCheck.isValue.message);
      return;
    }
    this.divisionStatList();
  };

  divisionStatList = async () => {
    const { date, dateType, depth, usageAPI, orgIdx } = this.props;

    let division = null;

    if (depth) {
      division = depth.two ? (depth.three ? depth.three : depth.two) : depth.one;
    }

    const params = {
      startdate: date
        ? date.sDate
        : moment()
            .startOf('month')
            .format('LLL'),
      enddate: date ? date.eDate : moment().format('LLL'),
      datetype: dateType ? dateType.value : 'MM',
      divisionidx: division,
      orgidx: orgIdx ? orgIdx.value : null
    };

    await usageAPI.divStatList(params);

    const { cmAPI } = this.props;
    cmAPI.changeExcel({
      excel: params
    });
  };

  render() {
    const {
        divStats,

        division
      } = this.props,
      formFn = {
        division: division,
        submitForm: this.submitForm
      };

    const { divisionFailed } = this.state;

    let loading = '';
    if (!((division || divisionFailed) && divStats)) {
      loading = <LoadingBar />;
    }

    return (
      <main>
        {loading}
        <DivisionStatsForm formFn={formFn} />
        <DivisionStatsResult />
      </main>
    );
  }
}

DivisionStats = connect(
  (state) => ({
    //common function call
    dateType: state.commons.dateType,
    date: state.commons.date,
    dateCheck: state.commons.dateCheck,
    division: state.commons.division,
    depth: state.commons.depth,
    orgIdx: state.commons.orgIdx,

    divStats: state.usage.divisionStats
  }),
  (dispatch) => ({
    cmAPI: bindActionCreators(
      {
        divisionList: cm_action.DivisionList,
        changeExcel: cm_action.ChangeExcel
      },
      dispatch
    ),

    usageAPI: bindActionCreators(
      {
        divStatList: usg_action.DivisionStatsList
      },
      dispatch
    )
  })
)(DivisionStats);

export default DivisionStats;
